import { NgModule } from '@angular/core';
import { ProductResource } from '@df/catalog/product/product.resource';
import { GiftcardsProductPlugin } from '@df/module-giftcards/giftcards-product.plugin';

declare module '@df/catalog/product/product' {
    interface Product {
        giftCard: GiftcardsProductPlugin;
    }
}

@NgModule()
export class DfModuleGiftcardsModule {
    constructor(productResource: ProductResource) {
        productResource.addPlugin(product => {
            product.giftCard = new GiftcardsProductPlugin(product);
        });
    }
}
